document.addEventListener("DOMContentLoaded", function () {
  if (window.__hbCustomerAuthInit) return;
  window.__hbCustomerAuthInit = true;

  var pwdPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  function setupPasswordValidation(form, pwd, opts) {
    if (!form || !pwd) return;

    var allowSignupFlag = !!(opts && opts.allowSignupFlag);

    function passwordOk() {
      return !!pwd.value && pwd.value.length >= 8 && pwdPattern.test(pwd.value);
    }

    function setPasswordMessageForSubmit() {
      pwd.setCustomValidity("");
      if (pwd.validity.valueMissing) return;
      if (!passwordOk()) {
        pwd.setCustomValidity(
          window.customerStrings?.passwordValidation ||
            "Password must have minimum 8 characters, at least 1 uppercase, lowercase, special character & number.",
        );
      }
    }

    function showNativeTooltipAndFocus() {
      if (typeof form.reportValidity === "function") form.reportValidity();
      var firstInvalid = form.querySelector(":invalid");
      if (firstInvalid) firstInvalid.focus();
    }

    function setGtmFlagIfValid() {
      if (!allowSignupFlag) return;
      try {
        localStorage.setItem("hasDLRegisteredEvent", "true");
      } catch (_) {}
      if (window.DebugActive) console.log("trigger signup", localStorage.getItem("hasDLRegisteredEvent"));
    }

    var submitters = form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])');
    submitters.forEach(function (btn) {
      btn.addEventListener(
        "click",
        function (e) {
          if (opts && opts.email) opts.email.setCustomValidity("");
          setPasswordMessageForSubmit();

          if (!form.checkValidity()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            showNativeTooltipAndFocus();
            return false;
          }

          setGtmFlagIfValid();
        },
        true,
      );
    });

    form.addEventListener(
      "submit",
      function (e) {
        if (opts && opts.email) opts.email.setCustomValidity("");
        setPasswordMessageForSubmit();

        if (!form.checkValidity()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showNativeTooltipAndFocus();
          return false;
        }

        if (allowSignupFlag) {
          try {
            sessionStorage.setItem("hb_account_created", String(Date.now()));
          } catch (_) {}
        }
      },
      true,
    );

    function silentClearIfValid() {
      pwd.setCustomValidity("");
      if (passwordOk()) {
        pwd.removeAttribute("aria-invalid");
        if (typeof pwd.reportValidity === "function") pwd.reportValidity();
      } else {
        if (pwd.value === "") pwd.removeAttribute("aria-invalid");
        else pwd.setAttribute("aria-invalid", "true");
      }
    }

    pwd.addEventListener("input", silentClearIfValid);
    pwd.addEventListener("change", silentClearIfValid);

    if (allowSignupFlag && typeof window.TriggerSignup === "function") {
      try {
        var original = window.TriggerSignup;
        window.TriggerSignup = function () {
          if (form.checkValidity()) setGtmFlagIfValid();
          return original.apply(this, arguments);
        };
      } catch (_) {}
    }
  }

  var regForm = document.querySelector(".create-account-page form");
  if (regForm) {
    setupPasswordValidation(regForm, document.getElementById("RegisterForm-password"), {
      email: document.getElementById("RegisterForm-email"),
      allowSignupFlag: true,
    });
  }

  // Activation link page (/account/activate/...): same password rules as the hint under the field.
  var activateForm = document.querySelector(".activate-account-page form");
  if (activateForm) {
    setupPasswordValidation(activateForm, document.getElementById("password"), {
      allowSignupFlag: false,
    });
  }

  var resetForm = document.querySelector(".reset-password-page form");
  if (resetForm) {
    setupPasswordValidation(resetForm, document.getElementById("password"), {
      allowSignupFlag: false,
    });
  }
});
